import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FakeMissingTranslationHandler, TranslateDefaultParser, TranslateFakeCompiler, TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })

export class TranslatesProcertService 
{
  constructor(private translate: TranslateService) { }
  translateText(key: string) 
  {
    let value = '';
    this.translate.get(key).subscribe((res: string) => { value = res; });
    return value;
  }
   translateInstant(key: string) {
    return this.translate.instant(key);
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function GetTranslateCompiler() {
  return new TranslateFakeCompiler();
}

export function GetTranslateParser() {
  return new TranslateDefaultParser();
}

export function GetFakeMissingTranslationHandler() {
  return new FakeMissingTranslationHandler();
}